// colour swatches

var dear = {
  product_option: function(){
      $('body').on('click', '.swatch .swatch-element', function(){
        var sw_value = $(this).attr('data-value');
        var img_id = $(this).attr('data-id');
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');

        //$(this).closest('.swatch').find('.toggler').removeClass('active');
         // $(this).parent('.toggler').addClass('active');

       // $(this).closest('form').find('.no-js').eq(optionIndex).find('select').val(sw_value).change();//.trigger('change');
       // console.log(sw_value);

        var sortBySelect = document.querySelector("select.all_option_select");
        sortBySelect.value = sw_value;
        sortBySelect.dispatchEvent(new Event("change"));

        if($('.image [data-product-image-wrapper][data-image-id="'+img_id+'"]').length > 0 ){
          $('.image [data-product-image-wrapper]').addClass('hide');
          $('.image [data-product-image-wrapper][data-image-id="'+img_id+'"]').removeClass('hide');
        }
    });
  }
}

$(function(){
  dear.product_option();
});
